import { pick } from 'lodash';

export function filterToObjectForQuery(filter) {
  let reducedFilter = pick(filter, ['filterCriteria']);
  return reducedFilter;
}

export function filterToBase64(filter) {
  let filterCriteria;
  if (!filter || !filter.filterCriteria) {
    filterCriteria = {};
  } else {
    filterCriteria = filter.filterCriteria;
  }

  const json = JSON.stringify(filterCriteria);
  return btoa(json);
}

export function base64ToFilter(base64String) {
  const json = atob(base64String);
  const filter = {};
  filter.filterCriteria = JSON.parse(json);

  return filter;
}
